import callApi from "./baseRequest";

const route = 'material';

interface Description {
    language: string,
    description: string,
    code: string
}

export interface Material {
    id: string,
    issuer: string,
    materialCode: string,
    descriptions: Description[]
};

interface MaterialResponse {
    materials: Material[],
    success: boolean,
    error: string
};

export function getMaterialsByIssuer(issuerCode: string): Promise<MaterialResponse> {
    const result: MaterialResponse = {
        materials: [],
        error: '',
        success: false
    };

    const response = callApi('GET', `${route}/list-products/${issuerCode}`)
    .then(resp => {
        if (resp?.length > 0 ?? false) {
            resp?.map((r: any) => {
                let material: Material = {
                    materialCode: r.materialCode,
                    issuer: r.issuer,
                    descriptions: r.descriptions,
                    id: r.id
                };

                result.materials.push(material);
            });
            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar produtos'
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};


export function getAllMaterials(): Promise<MaterialResponse> {
    const result: MaterialResponse = {
        materials: [],
        error: '',
        success: false
    };

    const response = callApi('GET', `${route}/get-all-active`)
    .then(resp => {
        if (resp?.length > 0 ?? false) {
            resp?.map((r: any) => {
                let material: Material = {
                    materialCode: r.materialCode,
                    issuer: r.issuer,
                    descriptions: r.descriptions,
                    id: r.id
                };

                result.materials.push(material);
            });
            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar produtos'
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};